import styled from 'styled-components';
import {Colors} from "../../components/constants";

export const Background = styled.div`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  background-repeat:no-repeat;
  background-position: center center;
`;

export const PlacedElementContainer = styled.div`
  position: absolute;
  left: ${(props) => props.x};
  top: ${(props) => props.y};
`;

export const TopButton = styled.div`
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  overflow: hidden;
  background-color: #FF6425;
  box-shadow: 0 0 14px 0 rgba(0,0,0,0.5);
  margin-bottom: 10px;
  
  :hover {
    background-color: #ff9162!important;  
  }
`;